'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _CompanyField = require('./CompanyField.scss');var styles = _interopRequireWildcard(_CompanyField);
var _CompanyTooltip = require('../CompanyTooltip/CompanyTooltip');var _CompanyTooltip2 = _interopRequireDefault(_CompanyTooltip);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

InputField = function (_Component) {_inherits(InputField, _Component);function InputField() {var _temp, _this, _ret;_classCallCheck(this, InputField);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      showTooltip: false }, _this.


    handleMouseEnter = function () {var _this$props$meta =
      _this.props.meta,touched = _this$props$meta.touched,error = _this$props$meta.error;

      if (error && touched) {
        _this.setState({ showTooltip: true });
      }
    }, _this.

    handleMouseLeave = function () {
      if (_this.state.showTooltip) {
        _this.setState({ showTooltip: false });
      }
    }, _this.

    input = null, _temp), _possibleConstructorReturn(_this, _ret);}InputField.prototype.

  render = function render() {var _this2 = this;var _props =
    this.props,input = _props.input,type = _props.type,placeholder = _props.placeholder,meta = _props.meta,isRtl = _props.isRtl,field_id = _props.field_id,isTextarea = _props.isTextarea,maxLength = _props.maxLength,disabledMaxLength = _props.disabledMaxLength;
    var id = field_id || 'company-contact-us-' + input.name;
    var InputTeg = isTextarea ? 'textarea' : 'input';

    return (
      _react2.default.createElement('label', {
          htmlFor: 'company-contact-us-' + input.name,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave },

        _react2.default.createElement(InputTeg, _extends({
          id: id },
        input, {
          type: type,
          placeholder: placeholder,
          className: (0, _classnames2.default)({ 'has-error': meta.error && !meta.active && meta.touched, touched: meta.touched }),
          ref: function ref(_ref) {_this2.input = _ref;},
          onClick: function onClick(evt) {return evt.stopPropagation();},
          maxLength: maxLength })),

        !disabledMaxLength && maxLength &&
        _react2.default.createElement('div', { className: styles.maxLength },
          _react2.default.createElement('p', null,
            input.value.length, ' / ', maxLength)),




        this.state.showTooltip && !meta.active &&
        _react2.default.createElement(_CompanyTooltip2.default, { tooltipFor: this.input, isRtl: isRtl },
          _react2.default.createElement('span', null, this.props.translateForError(meta.error)))));




  };return InputField;}(_react.Component);exports.default = InputField;


InputField.propTypes = {
  translateForError: _propTypes2.default.func,
  input: _propTypes2.default.object,
  type: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  meta: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  field_id: _propTypes2.default.string,
  isTextarea: _propTypes2.default.bool,
  disabledMaxLength: _propTypes2.default.bool,
  maxLength: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/CompanyField/CompanyField.js
// module id = 115
// module chunks = 0